<template>
  <div class="step-item">
    <div class="step-item__num">{{ step_code }}</div>
    <div class="step-item__content">
      <div class="step-item__title">{{ title }}</div>
      <div class="step-item__actions">
        <vx-tooltip text="Добавить подкупнкт">
          <vs-button
            type="flat"
            size="medium"
            icon-pack="feather"
            icon="icon-plus-circle"
            @click.prevent="$emit('add', id)"
          />
        </vx-tooltip>
        <vx-tooltip text="Редактировать пункт">
          <vs-button
            type="flat"
            size="medium"
            icon-pack="feather"
            icon="icon-edit"
            @click.prevent="$emit('edit', id)"
          />
        </vx-tooltip>
        <vx-tooltip text="Удалить пункт">
          <vs-button
            type="flat"
            size="medium"
            icon-pack="feather"
            icon="icon-trash-2"
            @click.prevent="handleClickOnDelete"
          />
        </vx-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    parent_id: {
      default: null
    },
    title: {
      type: String,
      required: true
    },
    step_code: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleClickOnDelete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Удаление пункта меню',
        text: 'Пункт меню будет удален из системы вместе с его подпунктами',
        accept: () => {
          this.$emit('delete', {
            id: this.id,
            parent_id: this.parent_id
          })
        },
        acceptText: 'Удалить',
        cancelText: 'Отменить'
      })
    }
  }
}
</script>

<style lang="scss">
.step-item-container {
}

.step-item-children {
  padding-left: 10%;
}

.step-item {
  display: flex;
  align-items: center;
  transition: .2s ease-in-out;
  margin-bottom: 20px;

  &__num {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #F0EFEF;
    color: #2C2C2C;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    margin-right: 28px;
  }

  &__content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-radius: 8px;
    border: 1px solid #CFCFCF;
    background: #fff;
    box-shadow: 1px 4px 10px rgba(0, 0, 0, 0.07);
    transition: .2s ease-in-out;
  }

  &__title {
    color: #2C2C2C;
    font-size: 14px;
    font-weight: 400;
  }

  &__actions {
    display: flex;
  }
}

[draggable=true] .step-item {
  transform: scale(.99);

  .step-item__content {
    box-shadow: none;
  }
}
</style>
